<template>
    <div class="cup-group-table-wrapper">
        <results-table :teams="teams" :games="games" :is-playoff-stage="isPlayoffStage" />
    </div>
</template>

<script setup>
import ResultsTable from '@/components/features/calendar/ResultsTable.vue';

const props = defineProps({
    teams: {
        type: Array,
        default: () => []
    },
    games: {
        type: Array,
        default: () => []
    },
    isPlayoffStage: {
        type: Boolean,
        default: false
    }
});
</script>


